import listenForResponseOnVoiceContent from './ListenForResponseOnVoiceContent';

const listenForResponseOnVoice = {
  name: 'Listen for response on Voice',
  Content: listenForResponseOnVoiceContent,
  setInitialContent: () => {
    return {};
  },
  valid: () => {
    return true;
  }
};

export default listenForResponseOnVoice;
